module.exports = __webpack_public_path__ + "static/media/diretor-locacao1.7125b07a.png";